import React, { useEffect, useRef, useState } from "react";
import Hoc from "../../components/HOC";
import Loader from "../../components/Loader";
import { Formik ,Form} from "formik";
import * as Yup from "yup";
import CustomDropdown from "../../components/CustomDropdown";
import { requestUsersListActionWithOutPagination, setResetStateUsersListWithOutPagination } from "../../Redux/UserState/UserActionCreator";
import { useDispatch, useSelector } from "react-redux";
import { requestProjectsById, setResetStateProjectsById } from "../../Redux/ProjectState/ProjectActionCreator";
import MuiDatePicker from "../../components/MuiDatePicker";
import moment from "moment";
import CustomDataTable from "../../components/CustomDataTable";
import {
  requestInvoiceList,
  requestInvoicePaymentDate,
  requestInvoicesById,
  requestReGenerateInvoicePDF,
  requestUpdateInvoice,
  setResetInvoicePaymentDate,
  setResetInvoicesInfoById,
  setResetReGenerateInvoicePDF,
  setResetStateInvoiceList,
  setResetUpdateInvoice,
  setInvoiceHours,
  resetInvoiceHours,
  requestInvoicesInfoById
} from "../../Redux/InvoiceState/InvoiceActionCreator";
import { toast } from "react-toastify";
import {
  MdEdit,
  MdEditDocument,
  MdOutlinePaid,
  MdOutlinePictureAsPdf,
  MdVisibility
  
} from "react-icons/md";
import CustomToolTip from "../../components/ToolTip";
import { requestGenerateInvoice } from "../../Redux/TimeSheetState/TimeSheetActionCreator";
import TextInput from "../../components/TextInput";
import { useParams } from "react-router-dom";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";


const validationSchema = Yup.object({
  userId: Yup.string().required("Employee is required"),
  projectName: Yup.string().required("Project is required"),
});

const Invoices = () => {
  const usersList = useSelector((state) => state.UsersListWithOutPagination);
  const projectsList = useSelector((state) => state.ProjectsByIdReducer);
  const invoicesList = useSelector((state) => state.InvoiceListReducer);
  const updateInvoice = useSelector((state) => state.UpdateInvoiceReducer);
  const invoicesById = useSelector((state) => state.InvoiceInfoById);
  const invoicePDFReducer = useSelector(
    (state) => state.ReGenerateInvoicePDFReducer
  );
  const invoicePaymentDateReducer = useSelector(
    (state) => state.InvoicePaymentDateReducer
  );
  const invoiceHours = useSelector((state) => state.InvoiceHoursReducer?.hours || "");
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRateModalOpen, setIsRateModalOpen] = useState(false);
  const [isPaidDateModalOpen, setIsPaidDateModalOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [hourRate, setHourRate] = useState("");
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowForPaid, setSelectedRowForPaid] = useState(null);
  const [paymentDate, setPaymentDate] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const formikRef = useRef();
  const { invoiceId } = useParams();
  const [isModalOpenView, setIsModalOpenView] = useState(false);
  const [sortBy, setSortBy] = useState(null); // null (ascending by default), 'desc' (descending)
 
 
  // const handleView = (row) => {
  //   setSelectedRow(row);
  //   setIsModalOpenView(true);
  //   dispatch(requestInvoicesInfoById(row.invoiceId));
  //   console.log(invoicesById, "invoicesById on view click");
  // };
  // console.log(invoicesById,"invoicesById")

  const handleView = (row) => {
    setSelectedRow(row);
    dispatch(setResetInvoicesInfoById());
    dispatch(requestInvoicesInfoById({ id: row.invoiceId }));
  };
  const handleEndDateSort = () => {
    const newSortBy = sortBy === 'asce' ? null : 'asce';
    setSortBy(newSortBy);
   
  };
  
  const columns = [
    {
      name: "Invoice Id",
      selector: (row) => row.invoiceId,
      
      minWidth: "200px"
    },
    {
      name: (
        <div className="flex items-center gap-2 cursor-pointer" onClick={handleEndDateSort}>
          <span>Invoice Date</span>
          {sortBy === 'desc' ? (
            <MdKeyboardArrowUp className="w-4 h-4 text-black-600" />
          ) : (
            <MdKeyboardArrowDown className="w-4 h-4 text-gray-400" />
          )}
        </div>
      ),
      selector: (row) => moment(row.invoiceDate).format("MM-DD-YYYY"),
      
    },
    {
      name: "Client Name",
      selector: (row) => row.clientName,
      sortable: false,
    },

    {
      name: "Client Email",
      selector: (row) => row.clientEmail,
      sortable: false,
      hide: "sm",
      cell: (row) => (
        <span className="text-md font-medium truncate">
          {row.clientEmail}
        </span>
      ),
       minWidth: "200px"
    },
    {
      name: "Invoice Period",
      selector: (row) => {
        const dates = row.invoicePeriod?.match(/\d{4}\/\d{2}\/\d{2}/g);
        return dates?.length === 2 ? (
          <span>
            <span className="font-bold">From: </span> {moment(dates[0], "YYYY/MM/DD").format("MM-DD-YYYY")} {" "}
            <span className="font-bold">To: </span> {moment(dates[1], "YYYY/MM/DD").format("MM-DD-YYYY")}
          </span>
        ) : (
          row.invoicePeriod
        );
      },
      grow : 2,
      
    },
    
    // {
    //   name: "Invoice Period",
    //   selector: (row) => moment(row.invoicePeriod).format("MM-DD-YYYY"),
    //   sortable: true,
    // },
    // {
    //   name: "Project Name",
    //   selector: (row) => row.projectName,
    //   sortable: true,
    // },

    {
      name: "Hours",
      selector: (row) => row.hours,
      
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEdit(row)}
            className="text-primary hover:text-blue-800"
            disabled={row.paymentDate !== null}
            style={{
              color: row.paymentDate !== null ? "#D1D5DB" : "", // Manually setting the color to gray when disabled
            }}
          >
            <MdEdit size={24} data-tip data-for="registerTip" />
            <CustomToolTip id="registerTip" title="Edit Hours" />
          </button>
          {/* <button
            onClick={() => handleViewPdf(row)}
            className="text-primary"
            disabled={row.paymentDate !== null}
            style={{
              color: row.paymentDate !== null ? "#D1D5DB" : "", // Manually setting the color to gray when disabled
            }}
          >
            <MdOutlinePictureAsPdf size={24} data-tip data-for="Pdf" />
            <CustomToolTip id="Pdf" title="Regenerate PDF" />
          </button> */}
          <button
            onClick={() => handlePaidDate(row)}
            className="text-primary"
            disabled={row.paymentDate !== null}
            style={{
              color: row.paymentDate !== null ? "#D1D5DB" : "", // Manually setting the color to gray when disabled
            }}
          >
            <MdOutlinePaid size={24} data-tip data-for="Paid" />
            <CustomToolTip id="Paid" title="Paid Date" />
          </button>

          <button
            onClick={() => handleView(row)}
            className="text-primary hover:text-primaryDark"
          >
            <MdVisibility size={24} data-tip data-for="View" />
            <CustomToolTip id="View" title="Details" />
          </button>
         
        </div>
      ),
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.paymentDate,
      style: {
        backgroundColor: "#E0FFE0",
        color: "black",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#E0FFE0",
          color: "#black",
        },
      },
    },
  ];

  const handlePageChange = (page) => {
    dispatch(
      requestInvoiceList({
        userId: invoicesList.userId,
        projectName: invoicesList.projectName,
        fromDate: invoicesList.fromDate,
        page: page,
        size: invoicesList.size,
        sortby: sortBy,
      })
    );
  };

  const handleRowsChange = (size) => {
    dispatch(
      requestInvoiceList({
        userId: invoicesList.userId,
        projectName: invoicesList.projectName,
        fromDate: invoicesList.fromDate,
        size: size,
        page: 0,
        sortby: sortBy,
      })
    );
  };

  // const handleViewPdf = (row) => {
  //   setIsRateModalOpen(true);
  //   setSelectedRow(row);
  //   dispatch(setResetReGenerateInvoicePDF());
  // };

  const handleConfirm = () => {
    const payload = {
      hours: invoiceHours,
      notes: "",
    };
    dispatch(requestUpdateInvoice(payload, selectedRows.invoiceId));
    // toast.success("Invoice is updated");
    // dispatch(setResetStateInvoiceList());
    // dispatch(
    //   requestInvoiceList({
    //     userId: invoicesList.userId,
    //     projectName: invoicesList.projectName,
    //     fromDate: invoicesList.fromDate,
    //     hours: invoicesList.hours,
    //     size: invoicesList.size,
    //     page: invoicesList.page,
    //   })
    // );
    // dispatch(setResetUpdateInvoice());
    // dispatch(resetInvoiceHours());
    // setIsModalOpen(false);
  };

  const handlePaymentDate = () => {
    dispatch(
      requestInvoicePaymentDate(
        selectedRowForPaid.invoiceId,
        selectedRowForPaid.userId,
        paymentDate
      )
    );
    toast.success("Invoice Payment Date is Updated");
    dispatch(setResetStateInvoiceList())
    dispatch(requestInvoiceList({
      userId: invoicesList.userId,
      projectName: invoicesList.projectName,
      fromDate: invoicesList.fromDate,
      size: invoicesList.size,
      page: invoicesList.page,
      sortby: sortBy,
    }));
    dispatch(setResetInvoicePaymentDate());
    setIsPaidDateModalOpen(false);
    setPaymentDate("");
  };

  const handleEdit = (row) => {
    setSelectedRows(row);
    setIsModalOpen(true);
    dispatch(setInvoiceHours(row.hours));
  };

  const handlePaidDate = (row) => {
    setIsPaidDateModalOpen(true);
    setSelectedRowForPaid(row);
  };

  const handleSubmit = (values) => {
    dispatch(
      requestInvoiceList({
        userId: values.userId,
        projectName: values.projectName,
        fromDate: values.fromDate ? moment(values.fromDate).format("MM-DD-YYYY") : "",
        page: 0,
        size: 10,
        sortby: sortBy,
      })
    );
  };

  const handleGenerate = () => {
    const numericRate = parseFloat(hourRate);
    setHourRate(numericRate);
    dispatch(requestReGenerateInvoicePDF(selectedRow.invoiceId, hourRate));
    toast.success("Invoice successfully generated!");
    setHourRate("");
    setIsRateModalOpen(false);
  };

  useEffect(() => {
    dispatch(setResetStateInvoiceList());
    dispatch(setResetReGenerateInvoicePDF());
    dispatch(requestUsersListActionWithOutPagination("USER"));
    dispatch(setResetStateProjectsById());
  }, []);
  
  useEffect(() => {
    if (
      projectsList?.response?.length > 0 &&
      selectedUserId &&
      formikRef.current
    ) {
      formikRef.current.setFieldValue(
        "projectName",
        projectsList.response[0].projectName
      );
    }
  }, [projectsList?.response, selectedUserId]);
  
  

  useEffect(() => {
    if (invoicesList?.error && !invoicesList?.loading && !invoicesList?.response?.length) {
      toast.error("No Invoices");
      dispatch(setResetStateInvoiceList());
    }
  }, [invoicesList]);

  useEffect(() => {
    if (invoicePDFReducer?.error && !invoicePDFReducer?.loading) {
      toast.error("No invoice Generated");
      dispatch(setResetReGenerateInvoicePDF());
    }
  }, [invoicePDFReducer]);

  useEffect(() => {
    if (
      invoicePaymentDateReducer?.response &&
      !invoicePaymentDateReducer?.loading
    ) {
      dispatch(
        requestInvoiceList({
          userId: invoicesList.userId,
          projectName: invoicesList.projectName,
          fromDate: invoicesList.fromDate,
          page: invoicesList.page,
          size: invoicesList.size,
          sortby: sortBy,
        })
      );
      dispatch(setResetInvoicePaymentDate());
    }
    if (
      invoicePaymentDateReducer?.error &&
      !invoicePaymentDateReducer?.loading
    ) {
      dispatch(setResetInvoicePaymentDate());
    }
  }, [invoicePaymentDateReducer]);

  useEffect(() => {
    if (!updateInvoice?.loading && updateInvoice?.response) {
      toast.success("Invoice is updated");
      dispatch(
        requestInvoiceList({
          userId: invoicesList.userId,
          projectName: invoicesList.projectName,
          fromDate: invoicesList.fromDate,
          hours: invoicesList.hours,
          page: invoicesList.page,
          size: invoicesList.size,
          sortby: sortBy,
        })
      );
      dispatch(setResetUpdateInvoice());
      setIsModalOpen(false);
    }
  }, [updateInvoice]);
   // Separate useEffect for sort changes to maintain current page
  useEffect(() => {
    // Only make API call if we have meaningful filters or if this is not the initial render
    if (invoicesList?.userId && invoicesList?.projectName) {
      dispatch(setResetStateInvoiceList());
      dispatch(
        requestInvoiceList({
          page: invoicesList?.page || 0,
          size: invoicesList?.size,
          userId: invoicesList.userId,
          projectName: invoicesList.projectName,
          fromDate: invoicesList.fromDate,
          sortby: sortBy,
        })
      );
    }
  }, [sortBy]);

  useEffect(() => {
    return () => {
      dispatch(setResetStateInvoiceList());
      dispatch(setResetStateProjectsById());
      dispatch(setResetStateUsersListWithOutPagination());
      dispatch(setResetReGenerateInvoicePDF());
      dispatch(setResetInvoicePaymentDate());
      dispatch(setResetUpdateInvoice());
    
    };
  }, []);



  useEffect(() => {
    if (!invoicesById?.loading) {
      if (invoicesById?.response) {
        // Success case - open modal
        setIsModalOpenView(true);
      } else if (invoicesById?.error) {
        // Error case - show toast and don't open modal
        toast.error("There are no details for viewing timesheets");
        setIsModalOpenView(false);
        dispatch(setResetInvoicesInfoById());
      }
    }
  }, [invoicesById]);

  return (
    <div className="w-full  p-6 ">
      <Loader isLoading={usersList?.loading || invoicesList?.loading || invoicesById?.loading} />
      <Formik
      innerRef={formikRef}
        initialValues={{
          userId: "",
          projectName: "",
          fromDate: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          setFieldValue,
          handleSubmit,
          handleBlur,
        }) => (
          <form
            onSubmit={handleSubmit}
            className="flex flex-wrap lg:flex-nowrap gap-5 my-5 items-center"
          >
            {/* Employee Dropdown */}
            <div className="lg:w-1/3 md:w-1/2 w-full">
              <CustomDropdown
                value={
                  usersList?.response?.find(
                    (user) => user.id == values?.userId
                  ) || null
                }
                name="userId"
                handleChange={(selectedOption) => {
                  dispatch(setResetStateInvoiceList());
                  dispatch(requestProjectsById(selectedOption?.id));
                  setFieldValue("userId", selectedOption?.id);
                  setSelectedUserId(selectedOption?.id);
                  setFieldValue("projectName", ""); 
                  setFieldValue("fromDate", "");
                }}
                customClasses="w-full text-left"
                placeholder="Select Employee"
                options={usersList?.response || []}
                handleGetOptionValue={(option) => option.id}
                handleGetOptionName={(option) =>
                  `${option.firstName} ${option.lastName}`
                }
              />
              {errors.userId && touched.userId ? (
                <p className="text-red-400 text-sm">{errors.userId}</p>
              ) : null}
            </div>

            {/* Project Dropdown */}
            <div className="lg:w-1/3 md:w-1/2 w-full">
              <CustomDropdown
                value={
                  projectsList?.response?.find(
                    (project) => project.projectName == values?.projectName
                  ) || null
                }
                name="projectName"
                handleChange={(selectedOption) => {
                  setFieldValue("projectName", selectedOption?.projectName);
                  setFieldValue("fromDate", "");
                }}
                customClasses="w-full text-left h-10"
                placeholder="Select Project"
                options={projectsList?.response || []}
                handleGetOptionValue={(option) => option.projectName}
                handleGetOptionName={(option) => option.projectName}
                isDisabled={!projectsList?.response?.length}
                className={`${
                  !projectsList?.response?.length
                    ? "cursor-not-allowed opacity-50"
                    : ""
                }`}
              />
              {errors.projectName && touched.projectName ? (
                <p className="text-red-400">{errors.projectName}</p>
              ) : null}
            </div>

            {/* Date Picker */}
            <div className="lg:w-1/3 md:w-1/2 w-full">
              <MuiDatePicker
                label="From Date"
                name="fromDate"
                value={values?.fromDate ? moment(values?.fromDate) : null}
                onChange={(date) => {
                  setFieldValue("fromDate", moment(date).format("MM-DD-YYYY"));
                }}
                disabled={false}
                className="w-full h-10"
                maxDate={moment()}
              />
            </div>
            <div className="lg:w-1/3 md:w-1/2 w-full flex gap-4">
              <button
                type="submit"
                className={`bg-primary text-white px-4 rounded-lg hover:bg-primaryDark h-10 flex-1 ${
                  !(values.userId && values.projectName)
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                disabled={!(values.userId && values.projectName)}
              >
                Submit
              </button>
            </div>
          </form>
        )}
      </Formik>


      {isModalOpenView && invoicesById?.response && (
        <InvoiceDetailsModal 
          isOpen={isModalOpenView}
          onClose={() => {
            setIsModalOpenView(false);
            dispatch(setResetInvoicesInfoById());
          }}
          data={invoicesById}
        />
      )}



      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-md w-[500px]">
            <h2 className="text-lg font-semibold mb-2">Update Invoice</h2>
            <input
              type="number"
              value={invoiceHours}
              onChange={(e) => dispatch(setInvoiceHours(e.target.value))}
              className="border p-2 w-full"
              placeholder="hours"
            />
            <label>Notes</label>
            <textarea
              type="text"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="border p-2 my-2 w-full"
            />
            <div className="flex justify-end mt-4">
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  dispatch(resetInvoiceHours());
                  setReason("")
                }}
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                className="bg-primary text-white px-4 py-2 rounded"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {isRateModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center  z-50">
          <div className="bg-white p-6 rounded shadow-md w-[500px]">
            <h2 className="text-lg font-semibold mb-2">Enter Rate per Hour</h2>
            <input
              type="number"
              value={hourRate}
              onChange={(e) => setHourRate(e.target.value)}
              className="border p-2 w-full"
              placeholder="Enter rate"
            />
            <div className="flex justify-end mt-4">
              <button
                onClick={() => {setIsRateModalOpen(false)
                  setHourRate("")
                }} 
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleGenerate}
                className="bg-primary text-white px-4 py-2 rounded"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {isPaidDateModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center  z-50">
          <div className="bg-white p-6 rounded shadow-md w-[500px]">
            <h2 className="text-lg font-semibold mb-2">Enter Payment Date</h2>
            <MuiDatePicker
              label="Payment Date"
              value={paymentDate ? moment(paymentDate) : null}
              onChange={(date) => {
                setPaymentDate(moment(date).format("YYYY-MM-DD"));
              }}
              disabled={false}
              className="w-full h-10"
              minDate={ moment(selectedRowForPaid.invoiceDate) } // Min date is invoiceDate, fallback to today if invoiceDate is not set
              maxDate={moment()} // Max date is today
            />
            <div className="flex justify-end mt-4">
              <button
                onClick={() => {
                  setIsPaidDateModalOpen(false);
                  setPaymentDate("");
                }}
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handlePaymentDate}
                className="bg-primary text-white px-4 py-2 rounded"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <div>
        <CustomDataTable
          columns={columns}
          data={invoicesList?.response?.content || []}
          paginationTotalRows={invoicesList?.response?.totalElements}
          enableSearch={false}
          serverPagenation
          handleChangePage={handlePageChange}
          handleRowsChange={handleRowsChange}
          conditionalRowStyles={conditionalRowStyles}
          // selectableRows={true}
          fixedHeaderScrollHeight={"62vh"}
        />
      </div>
    </div>
  );
};

// Invoice Details Modal Component
const InvoiceDetailsModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data) return null;

  return (
    <Formik
      initialValues={{
        invoiceId: data?.response?.invoice?.invoiceId || '',
        clientEmail: data?.response?.invoice?.clientEmail || '',
        totalHours: data?.response?.invoice?.totalhours || '',
        invoiceDate: data?.response?.invoice?.invoiceDate ? moment(data.response.invoice.invoiceDate).format("MM-DD-YYYY") : '',
        invoicePeriod: data?.response?.invoice?.invoicePeriod || '',
        projectName: data?.response?.invoice?.projectName || '',
      }}
      enableReinitialize
      onSubmit={() => {}} // No submit action, just for display
    >
      {({ values }) => (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-0 rounded-2xl shadow-2xl w-11/12 md:w-3/4 lg:w-2/4 relative z-50 max-h-[calc(100vh-0.5rem)] border border-gray-200">
            <div className="overflow-y-auto" style={{ maxHeight: '90vh' }}>
              {/* Modal Header */}
              <div className="sticky top-0 bg-white z-10 border-b border-gray-200 flex items-center justify-between px-6 py-4 gap-4 rounded-t-2xl">
                <div className="flex items-center gap-3">
                  <h2 className="text-primary text-2xl font-bold tracking-tight">Invoice Details</h2>
                </div>
                <button
                  onClick={onClose}
                  className="text-primary hover:text-primaryDark transition-colors duration-150 p-2 rounded-full focus:outline-none absolute top-4 right-4"
                  type="button"
                  aria-label="Close"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <Form>
                <div className="flex flex-col gap-6 mb-4 px-8 pt-6 pb-2">
                  {/* Row 1 */}
                  <div className="flex flex-col sm:flex-row gap-6 sm:gap-8">
                    <div className="w-full">
                      <TextInput
                        handleChange={() => {}}
                        value={values.invoiceId}
                        name="invoiceId"
                        legend
                        isDisabled
                        placeholder="Invoice ID"
                        customClasses="bg-gray-50 border-gray-200"
                      />
                    </div>
                    <div className="w-full">
                      <TextInput
                        handleChange={() => {}}
                        value={values.clientEmail}
                        name="clientEmail"
                        legend
                        isDisabled
                        placeholder="Client Email"
                        customClasses="bg-gray-50 border-gray-200"
                        type="email"
                      />
                    </div>
                  </div>
                  {/* Row 2 */}
                  <div className="flex flex-col sm:flex-row gap-6 sm:gap-8">
                    <div className="w-1/2">
                      <TextInput
                        handleChange={() => {}}
                        value={values.totalHours}
                        name="totalHours"
                        legend
                        isDisabled
                        placeholder="Total Hours"
                        customClasses="bg-gray-50 border-gray-200"
                      />
                    </div>
                   
                    <div className="w-1/2">
                      <TextInput
                        handleChange={() => {}}
                        value={values.projectName}
                        name="projectName"
                        legend
                        isDisabled
                        placeholder="Project Name"
                        customClasses="bg-gray-50 border-gray-200"
                      />
                    </div>

                    <div className="w-1/2">
                      <TextInput
                        handleChange={() => {}}
                        value={values.invoicePeriod}
                        name="invoicePeriod"
                        legend
                        isDisabled
                        placeholder="Invoice Period"
                        customClasses="bg-gray-50 border-gray-200 w-full"
                      />
                    </div>
                  </div>
                 
                </div>
              </Form>

              {/* Section Divider */}
              <div className="px-6">
                <div className="border-t border-dashed border-gray-200" />
              </div>

              {/* Timesheets Section */}
              <div className="px-6 py-2">
                <h2 className="text-primary text-lg font-semibold flex items-center mb-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Timesheet Details
                </h2>

                {data?.loading ? (
                  <div className="text-center p-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
                    <p className="text-gray-500 mt-2">Loading invoice details...</p>
                  </div>
                ) : data?.error ? (
                  <div className="text-center p-8 bg-red-50 rounded-lg border border-red-200">
                    <p className="text-red-500">
                      There are no details for viewing timesheets
                    </p>
                  </div>
                ) : data?.response?.timesheets?.length > 0 ? (
                  <div className="bg-gray-50 rounded-lg p-2">
                    <CustomDataTable
                      columns={[
                        {
                          name: "Employee Name",
                          selector: (row) => row.employeeName,
                          sortable: true,
                          minWidth: "200px"
                        },
                        {
                          name: "Hours",
                          selector: (row) => row.hours,
                          sortable: true,
                        },
                        {
                          name: "Start Date",
                          cell: (row) => (
                            <span>
                              {row.startDate}
                            </span>
                          ),
                        
                          minWidth: "100px"
                        },
                        {
                          name: "End Date",
                          cell: (row) => (
                            <span>
                              {row.endDate}
                            </span>
                          ),
                        
                          minWidth: "100px"
                        },
                      ]}
                      data={data.response.timesheets || []}
                      pagination={false}
                      fixedHeaderScrollHeight={"40vh"}
                      
                    />
                  </div>
                ) : (
                  <div className="text-center p-8 bg-gray-50 rounded-lg border border-dashed border-gray-200">
                    <p className="text-gray-400">
                      No timesheet details available
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
};

export default Hoc(Invoices);
